import { Entity } from '../entity';
import { UUID } from '../uuid/entity';

interface TacticProps {
    id: string;
    name?: string;
    label: string;
    description: string;
    srcId?: string;
    url?: string;
    techniqueIds: string[];
    isCustom?: boolean;
}

export class Tactic extends Entity {
    label?: string;
    description: string;
    techniqueIds: string[];
    srcId?: string;
    url?: string;
    isCustom: boolean;

    constructor({
        id,
        name,
        label,
        description,
        techniqueIds,
        srcId,
        url,
        isCustom,
    }: TacticProps) {
        super({ id, name });
        this.label = label;
        this.description = description;
        this.techniqueIds = techniqueIds;
        this.srcId = srcId;
        this.url = url;
        this.isCustom = isCustom ?? false;
    }

    static new({
        name,
        label,
        description,
        techniqueIds,
        srcId,
        url,
        isCustom,
    }: Omit<TacticProps, 'id'>): Tactic {
        const uuid = new UUID();
        return new Tactic({
            id: uuid.toString(),
            name,
            label,
            description,
            techniqueIds,
            srcId,
            url,
            isCustom,
        });
    }
}
